module.exports = __webpack_public_path__ + "img/fig17.23b9c419.jpg";